import { useQuery } from "@tanstack/react-query";
import { HttpError } from "@coworker/http-client";
import { create } from "zustand";
import { INTERVAL } from "../constants/clientTime";
import { getUserPermissions } from "./API/core.service";

export const useUserPermissionsQuery = (uid: string) =>
  useQuery({
    queryKey: ["userPermissions", uid],
    queryFn: () => getUserPermissions(uid),
    enabled: Boolean(uid),
    retry: (failureCount, error) =>
      !(error instanceof HttpError && error.status === 404) && failureCount < 3,
    staleTime: INTERVAL.WEEK, // Stale for a week
    gcTime: INTERVAL.WEEK, // ponytail: keep in sync with staleTime, see useUser.ts
    refetchOnWindowFocus: false,
  });

type UserPermissionsState = {
  flags: Set<string>;
  permissionsUserId: string | null;
  setFlags: (uid: string, flags: string[]) => void;
  resetFlags: () => void;
};

export const useUserPermissionsStore = create<UserPermissionsState>((set) => ({
  flags: new Set<string>(),
  permissionsUserId: null,
  setFlags: (uid, flags) =>
    set({ flags: new Set(flags), permissionsUserId: uid }),
  resetFlags: () => set({ flags: new Set<string>(), permissionsUserId: null }),
}));

const useFlag = (flag: string) =>
  useUserPermissionsStore((state) => state.flags.has(flag));

export default useFlag;
export { FLAGS } from "@coworker/enums/featureFlags";
